import { Component, OnInit , AfterViewInit } from '@angular/core';
import {FormGroup,FormBuilder,Validators,FormControl} from '@angular/forms';
import {DataService} from '../data.service';
import {Router} from "@angular/router";
import {HomeComponent} from '../home/home.component';

declare var $ : any;

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit,AfterViewInit {
  contactForm:FormGroup;
  userTypeId:number=-1;
  planId:number=-1;
  isNext:boolean=false;
  btnDisable:boolean;
  constructor(
  private fb:FormBuilder,
  private service:DataService,
  private home:HomeComponent,
  private router: Router
  ) {
    this.contactForm=this.fb.group({
      'fname':['',Validators.required],
      'lname':['',Validators.required],
      'email':['',Validators.compose([Validators.required,Validators.email])],
      'message':['',Validators.required],
      'org':['',Validators.required],
      'phno':['',Validators.compose([Validators.required,Validators.pattern("^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$")])]

    })

  }

  ngOnInit() {
    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));

  }

  ngAfterViewInit(){
      $(window).scrollTop(0);
    $('.cd-header').css('backgroundColor','rgb(147, 18, 70)');
  }

  contactUs(form){
    this.btnDisable = false;
    if(!form.valid){
        this.validateForm(form);

    if(!form.controls['fname'].valid){
      this.service.alert('Please enter first name','error');
      return false;
    }

    if(!form.controls['lname'].valid){
      this.service.alert('Please enter last name','error');
      return false;
    }

    if(!form.controls['email'].valid){
      if(form.controls['email'].hasError('required')){
          this.service.alert('Please enter your email','error');
      } else {
          this.service.alert('Invalid email format','error');
      }

      return false;
    }

    if(!form.controls['phno'].valid){
      if(form.controls['phno'].hasError('required')){
        this.service.alert('Please enter your mobile no','error');

      } else {
          this.service.alert('Invalid phone no format','error');
      }

      return false;
    }

    if(!form.controls['org'].valid){
        this.service.alert('Please enter your organisation','error');
          return false;
    }

    if(!form.controls['message'].valid){
      this.service.alert('Please enter your message','error');
      return false;
    }
  } else {
      const inputJson={
	      "CompanyName":form.controls['org'].value,
        "Email":form.controls['email'].value,
      	"FirstName":form.controls['fname'].value,
      	"LastName":form.controls['lname'].value,
      	"Message":form.controls['message'].value,
      	"Mobile":form.controls['phno'].value,
      	"UserType": localStorage.getItem("UserTypeId") != null ? parseInt(localStorage.getItem("UserTypeId")) : -1
      }
     // console.log(inputJson)
      this.btnDisable = true;
      this.service.ContactUs(inputJson)
      .subscribe(
        (result:any[])=>{
          if(result['Status']=="Success"){
            this.btnDisable = false;
            this.service.alert('Your query has been submitted','success');
            this.router.navigate(['/']);
          } else {
            this.btnDisable = false;
            this.service.alert(result['Message'],"error");
          }
        },
        (error)=>{
          this.btnDisable = false;
         // console.log(error);
        }
      )
    }
  }

  validateForm(group:FormGroup){
    if(group instanceof FormGroup){
      Object.keys(group.controls).forEach(key => {
    group.get(key).markAsTouched();
  });
    }

    if(group instanceof FormControl){
      this.validateForm(group);
    }

  }

  showActiveModule(pvarChoice){
    this.home.showActiveModule(pvarChoice);
  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/contact-us/contact-us.component.ts